import React, {useState} from "react";
import {Button, Card, Row} from "react-bootstrap";
import "./AIRegister.css";
import Swal from "sweetalert2";
import DocumentSelector from "./DocumentSelector";
import FileUploader from "./FileUploader";
import CameraCapture from "./CameraCapture";
import IdentityPreview from "./IdentityPreview";
import {saveIdentityPatient, scanIdentityDocument} from "./aiApi";
export default function AIIdentityCenter({
                                             patient, setPatient, userName, ipAddress, userLocation
                                         }) {
    // =====================================================
    // DOCUMENT TYPES
    // =====================================================
    const [selectedDocument, setSelectedDocument] = useState("");
    const [file, setFile] = useState(null);
    const [ocrLoading, setOcrLoading] = useState(false);
    // =====================================================
    // MOCK OCR RESULT
    // (will replace with API)
    // =====================================================
    const [identityPatient, setIdentityPatient] = useState({
        confidence: 0, name: "", dob: "", gender: "", mobile: "", address: "", idNumber: ""
    });
    const processDocument = async () => {
        if (!file) {
            alert("Please upload document first.");
            return;
        }
        try {
            setOcrLoading(true);
            const response = await scanIdentityDocument(file, selectedDocument);
            console.log("FULL RESPONSE", response);
            if (response.success) {
                const doc = response.document;
                const patient = response.patient;
                setIdentityPatient({
                    patient: `${patient.first_name} ${patient.middle_name || ""} ${patient.last_name}`
                        .replace(/\s+/g, " ")
                        .trim(),
                    gender: patient.gender,
                    dob: patient.dob,
                    age: patient.age,
                    mobile: patient.mobile,
                    address1: patient.address1,
                    abha: patient.identity_number,
                    confidence: response.confidence
                });
            } else {
                alert(response.message || "OCR Failed");
            }
        } catch (error) {
            console.log("FULL ERROR", error);
            if (error.response) {
                console.log("STATUS", error.response.status);
                console.log("DATA", error.response.data);
            }
            alert("Unable to process document");
        } finally {
            setOcrLoading(false);
        }
    };
    // =====================================================
    // FILE SELECT
    // =====================================================
    const handleFile = (e) => {
        const selected = e.target.files[0];
        setFile(selected);
        /*
            Later:

            upload file
            OCR processing
            extract details

        */
    };
    // =====================================================
    // APPLY TO PATIENT SUMMARY
    // =====================================================
    const applyIdentity = async () => {
        if (!identityPatient) {
            alert("Please scan the document first.");
            return;
        }
        try {
            const patientData = {
                title: "",
                first_name: identityPatient.name?.split(" ")[0] || "",
                middle_name: identityPatient.name?.split(" ").length > 2 ? identityPatient.name.split(" ")[1] : "",
                last_name: identityPatient.name?.split(" ").slice(-1)[0] || "",
                gender: identityPatient.gender === "Male" ? "M" : identityPatient.gender === "Female" ? "F" : "",
                dob: identityPatient.dob,
                age: identityPatient.age,
                mobile: "",
                email: "",
                address1: identityPatient.address,
                address2: "",
                city: "",
                district: "",
                state: "",
                country: "India",
                pincode: identityPatient.pincode,
                identity_type: selectedDocument,
                identity_number: identityPatient.idNumber
            };
            const response = await saveIdentityPatient(identityPatient, userName, ipAddress, userLocation, file?.name);
            if (response.success) {
                Swal.fire({
                    icon: "success",
                    title: "Patient Registered",
                    html: `<b>Patient ID :</b> ${response.pat_id}`,
                    confirmButtonText: "OK"
                }).then(() => {
                    window.location.reload();
                });
            } else {
                Swal.fire({
                    icon: "error", title: "Save Failed", text: response.message || JSON.stringify(response.errors)
                });
            }
        } catch (error) {
            console.log(error);
            Swal.fire({
                icon: "error", title: "Error", text: "Unable to save patient."
            });
        }
    };
    return (<Card className="shadow-lg border-0 rounded-4 mb-3">


        <Card.Header
            className="bg-success text-white"
        >

            <strong>
                🪪 AI Identity Center
            </strong>

        </Card.Header>


        <Card.Body>


            {/* ===================================
                        DOCUMENT SELECT
                ==================================== */}

            <Row className="g-2 mb-4">

                <DocumentSelector

                    selectedDocument={selectedDocument}

                    setSelectedDocument={setSelectedDocument}

                />

            </Row>


            {/* ===================================
                        UPLOAD
                ==================================== */}


            {selectedDocument && (<Card
                className="bg-light mb-3"
            >

                <Card.Body>

                    <FileUploader

                        file={file}

                        setFile={setFile}

                    />
                    <Button

                        variant="primary"

                        className="w-100 mt-3"

                        disabled={!file || ocrLoading}

                        onClick={processDocument}

                    >

                        {ocrLoading ? "🔄 Processing..." : "🤖 Scan Document"}


                    </Button>

                </Card.Body>


            </Card>)}


            {/* ===================================
                        CAMERA
                ==================================== */}


            {selectedDocument && (<CameraCapture

                setFile={setFile}

            />)}


            {/* ===================================
                        IDENTITY PREVIEW
                ==================================== */}


            {selectedDocument && (<Card>


                <Card.Header>

                    Identity Preview

                </Card.Header>


                <Card.Body>

                    <IdentityPreview

                        identityPatient={identityPatient}

                        setIdentityPatient={setIdentityPatient}

                        applyIdentity={applyIdentity}

                    />


                </Card.Body>


            </Card>)}


        </Card.Body>


    </Card>);
}